import { shapesLayout1 } from './shapes-layouts/shapes-layout-1'
import { shapesLayout2 } from './shapes-layouts/shapes-layout-2'
import { shapesLayout3 } from './shapes-layouts/shapes-layout-3'
import { shapesLayout4 } from './shapes-layouts/shapes-layout-4'
import { shapesLayout5 } from './shapes-layouts/shapes-layout-5'

export const shapesLayout = [
  shapesLayout1,
  shapesLayout2,
  shapesLayout3,
  shapesLayout4,
  shapesLayout5
]
